import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../services/axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (!email) {
        setError('Email wajib diisi');
        setLoading(false);
        return;
      }

      console.log('🔵 Sending forgot password request:', email);

      const res = await axios.post('/auth/forgot-password', {
        email: email.trim(),
      });

      console.log('🟢 Forgot password response:', res.data);
      
      // 🚨 PERBAIKAN: Cek success flag dari backend
      if (res.data.success) {
        setSuccess(res.data.message || 'Link reset password telah dikirim ke email Anda!');
        
        // Untuk development, tampilkan link jika ada
        if (res.data.resetLink) {
          console.log('🔗 Development Reset Link:', res.data.resetLink);
          // Opsional: Bisa tambahkan tampilan link di UI untuk development
          setSuccess(prev => prev + ' (Check console untuk link)');
        }
      } else {
        setError(res.data.message || 'Terjadi kesalahan');
      }
      
    } catch (err) {
      console.error('❌ Forgot password failed:', err.response?.data || err.message);
      
      // 🚨 PERBAIKAN: Handle error response dengan benar
      if (err.response?.status === 404) {
        setError('Email tidak terdaftar dalam sistem');
      } else if (err.response?.status === 400) {
        setError('Email tidak valid');
      } else {
        const msg = err.response?.data?.message || err.message || 'Terjadi kesalahan. Coba lagi.';
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Lupa Kata Sandi</h2>
        <p style={styles.subtitle}>
          Masukkan email Anda untuk menerima link reset password
        </p>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
            disabled={loading}
            autoComplete="email"
          />
          <button
            type="submit"
            style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
            disabled={loading}
          >
            {loading ? 'Mengirim...' : 'Kirim Link Reset'}
          </button>
        </form>

        {/* 🎯 TAMPILKAN LINK UNTUK DEVELOPMENT */}
        {success && process.env.NODE_ENV !== 'production' && (
          <div style={styles.devBox}>
            <p style={styles.devTitle}>🛠️ Development Mode</p>
            <p style={styles.devText}>
              Untuk testing, buka console browser untuk melihat reset link
            </p>
            <button 
              onClick={() => {
                // Redirect ke reset page dengan token dummy untuk testing
                navigate('/reset-password?token=dev-test-token-123');
              }}
              style={styles.devButton}
            >
              Test Reset Password Page
            </button>
          </div>
        )}

        <p style={styles.link}>
          <Link to="/login" style={styles.a}>
            Kembali ke Login
          </Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a3c6d, #4a90e2)',
    fontFamily: '"Segoe UI", sans-serif',
  },
  card: {
    width: 420,
    padding: '40px 30px',
    background: 'white',
    borderRadius: 16,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    textAlign: 'center',
  },
  title: {
    margin: 0,
    marginBottom: 8,
    fontSize: 28,
    color: '#1a3c6d',
    fontWeight: 'bold',
  },
  subtitle: {
    margin: '0 0 20px',
    color: '#666',
    fontSize: 14,
  },
  input: {
    width: '100%',
    padding: '14px',
    margin: '12px 0',
    borderRadius: 8,
    border: '1px solid #ddd',
    fontSize: 16,
    boxSizing: 'border-box',
    transition: 'border-color 0.3s',
  },
  button: {
    width: '100%',
    padding: '14px',
    background: '#1a3c6d',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 10,
    transition: 'background 0.3s',
  },
  error: {
    color: '#e74c3c',
    background: '#fadad7',
    padding: '10px',
    borderRadius: 8,
    margin: '10px 0',
    fontSize: 14,
  },
  success: {
    color: '#27ae60',
    background: '#d5f4e6',
    padding: '10px',
    borderRadius: 8,
    margin: '10px 0',
    fontSize: 14,
  },
  // 🎯 Style untuk development box
  devBox: {
    margin: '15px 0',
    padding: '15px',
    background: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '8px',
    textAlign: 'center',
  },
  devTitle: {
    margin: '0 0 8px 0',
    fontWeight: 'bold',
    color: '#856404',
    fontSize: '14px',
  },
  devText: {
    margin: '0 0 10px 0',
    color: '#856404',
    fontSize: '12px',
  },
  devButton: {
    padding: '8px 16px',
    background: '#856404',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer',
  },
  link: {
    margin: '20px 0 10px',
    fontSize: 14,
    color: '#555',
  },
  a: {
    color: '#1a3c6d',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

export default ForgotPassword;
